import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { log } from "../Logging";
import { getOptionConfigOptions } from "./ClientContextOptionalConfigHelper";
export var DATA_CLIENT_KEY = "data-client-key";
export var DATA_TENANT_NAME = "data-tenant-name";
export var DATA_GROUP_NAME = "data-group-name";
export var DATA_LOCALE = "data-locale";
export var DATA_PERSISTENCE = "data-persistence";
export var DATA_HIW = "data-how-it-works";
export var DATA_THEME_CONTENT = "data-theme-content";
export var DATA_APP_VISIBLE = "data-app-visible";
export var DATA_USERNAME = "data-username";
export var DATA_EMAIL = "data-email";
export var DATA_QUESTION = "data-question";
export var DATA_MSG_SOURCE = "data-message-source";
export var DATA_EXTRA_INFO = "data-extra-info";
export var DATA_MSG_TENANT_ID = "data-tenant-message-id";
export var DATA_MSG_TYPE = "data-message-type";
export var DATA_MSG_PROP1 = "data-message-prop1";
export var DATA_MSG_PROP2 = "data-message-prop2";
export var DATA_MSG_PROP3 = "data-message-prop3";
export var DATA_MSG_PROP4 = "data-message-prop4";
export var DATA_MSG_PROP5 = "data-message-prop5";
export var DATA_MSG_PROP6 = "data-message-prop6";
export var DATA_MSG_PROP7 = "data-message-prop7";
export var DATA_MSG_PROP8 = "data-message-prop8";
export var DATA_MSG_PROP9 = "data-message-prop9";
export var DATA_MIN_QUESTION_CHAR_COUNT = "data-min-question-char-count";
export var DATA_FAB_TEXT = "data-fab-text";
export var DATA_FAB_MOBILE_TEXT = "data-fab-mobile-text";
export var DATA_MSG_PROP1_URL_PARAM = "data-message-prop-1-url-param";
export var DATA_FAB_BUTTON_STYLE = "data-fab-button-style";
export var DATA_MOBILE = "data-mobile";
export var DATA_MOBILE_ENABLED = "data-mobile-capture";
export var DATA_POWERED_BY = "data-powered-by";
export var DATA_ANIMATION = "data-animation";
export var DATA_HEADER_BUTTONS_HOVER = "data-header-buttons-hover";
export var DATA_FAB_CLOSE_ICON = "data-fab-close-icon";
export var DATA_RIGHT_OFFSET = "data-right-offset";
export var DATA_BOTTOM_OFFSET = "data-bottom-offset";
export var DATA_EXPANDABLE_FAB = "data-expandable-fab";
export var DATA_REACH_OUT_MODE = "data-reach-out-mode";
export var DATA_NEW_CONVERSATION_MODE = "data-new-conversation-mode";
export var DATA_FIXED_MANDATORY_ATTRIBUTES = "data-fixed-mandatory-attributes";
var MANDATORY_ATTRIBUTES = ["apiKey", "tenantName", "groupName", "locale"];

var ClientContext = /*#__PURE__*/function () {
  function ClientContext() {
    _classCallCheck(this, ClientContext);
  }

  _createClass(ClientContext, null, [{
    key: "validateConfig",
    value: function validateConfig(rootId) {
      var _this = this;

      this._rootElement = document.getElementById(rootId);

      if (!this._rootElement) {
        log.error("Unable to find <div id=\"".concat(rootId, "\" ..> in the DOM"));
        return false;
      }

      this._apiKey = this._rootElement.getAttribute(DATA_CLIENT_KEY);

      if (!this._apiKey) {
        log.error("Unable to find ".concat(DATA_CLIENT_KEY, " on the limitless root tag, please check your syntax"));
        return false;
      }

      this._tenantName = this._rootElement.getAttribute(DATA_TENANT_NAME);

      if (!this._tenantName) {
        log.error("Unable to find ".concat(DATA_TENANT_NAME, " on the limitless root tag, please check your syntax"));
        return false;
      }

      this._groupName = this._rootElement.getAttribute(DATA_GROUP_NAME);

      if (!this._groupName) {
        log.error("Unable to find ".concat(DATA_GROUP_NAME, " on the limitless root tag, please check your syntax"));
        return false;
      }

      this._locale = this._rootElement.getAttribute(DATA_LOCALE);

      if (!this._locale) {
        // an array of preferred languages - let's make sure it exists as it's experimental ;)
        // https://developer.mozilla.org/de/docs/Web/API/NavigatorLanguage/languages
        if (navigator.languages) {
          // poition 0 is the most perferred language
          var browserLanguage = navigator.languages[0];

          if (browserLanguage) {
            //some languages may just be 2 chars for example "de", this will change that to be "de-DE"
            if (browserLanguage.length === 2) {
              browserLanguage += "-".concat(browserLanguage.toLocaleUpperCase());
            }

            this._locale = browserLanguage;
          }
        } else {
          log.warn("Could not detect browser language, defaulting to en-GB");
          this._locale = "en-GB";
        }
      }

      this._extraInfo = this._rootElement.getAttribute(DATA_EXTRA_INFO);

      if (this._extraInfo) {
        // json structure containing extra info
        // check for valid json
        try {
          this._extraInfo = JSON.parse(this._extraInfo);
        } catch (_unused) {
          this._extraInfo = null;
        }
      }

      getOptionConfigOptions().forEach(function (config) {
        var domValue = _this._rootElement.getAttribute(config.attributeKey);

        if (!domValue) {
          _this[config.classProp] = config.defaultValue;
        } else {
          if (config.valueExtractor) {
            _this[config.classProp] = config.valueExtractor(domValue);
          } else {
            if (domValue !== "false") {
              _this[config.classProp] = true;
            } else {
              _this[config.classProp] = false;
            }
          }
        }
      });
      this._themeContent = this._rootElement.getAttribute(DATA_THEME_CONTENT);
      this._tenantMsgSource = this._rootElement.getAttribute(DATA_MSG_SOURCE) || window.location.href;
      this._userName = this._rootElement.getAttribute(DATA_USERNAME);
      this._userEmail = this._rootElement.getAttribute(DATA_EMAIL);
      this._userQuestion = this._rootElement.getAttribute(DATA_QUESTION);
      this._userMobile = this._rootElement.getAttribute(DATA_MOBILE);
      this._userMobileEnabled = this._rootElement.getAttribute(DATA_MOBILE_ENABLED);
      this._tenantMsgId = this._rootElement.getAttribute(DATA_MSG_TENANT_ID) || "";
      this._tenantMsgType = this._rootElement.getAttribute(DATA_MSG_TYPE) || "question"; // if populated, 3 values should be validated

      if (this._tenantMsgType !== "question" && this._tenantMsgType !== "query" && this._tenantMsgType !== "complaint") {
        this._tenantMsgType = "question";
      }

      this._msgProp1 = this._rootElement.getAttribute(DATA_MSG_PROP1) || "";

      var msgProp1URLParam = this._rootElement.getAttribute(DATA_MSG_PROP1_URL_PARAM);

      if (msgProp1URLParam) {
        var isPropPresent = this.validateQueryParameters(msgProp1URLParam);

        if (isPropPresent) {
          this._msgProp1 = this["_".concat(msgProp1URLParam)];
        }
      }

      this._msgProp2 = this._rootElement.getAttribute(DATA_MSG_PROP2) || "";
      this._msgProp3 = this._rootElement.getAttribute(DATA_MSG_PROP3) || "";
      this._msgProp4 = this._rootElement.getAttribute(DATA_MSG_PROP4) || "";
      this._msgProp5 = this._rootElement.getAttribute(DATA_MSG_PROP5) || "";
      this._msgProp6 = this._rootElement.getAttribute(DATA_MSG_PROP6) || "";
      this._msgProp7 = this._rootElement.getAttribute(DATA_MSG_PROP7) || "";
      this._msgProp8 = this._rootElement.getAttribute(DATA_MSG_PROP8) || "";
      this._msgProp9 = this._rootElement.getAttribute(DATA_MSG_PROP9) || "";
      this._fabText = this._rootElement.getAttribute(DATA_FAB_TEXT) || "";
      this._fabMobileText = this._rootElement.getAttribute(DATA_FAB_MOBILE_TEXT) || "";
      this._minQuestionCharCount = this._rootElement.getAttribute(DATA_MIN_QUESTION_CHAR_COUNT) || 50;

      try {
        this._minQuestionCharCount = parseInt(this._minQuestionCharCount);
      } catch (error) {
        log.warn("Invalid value for ".concat(DATA_MIN_QUESTION_CHAR_COUNT, ", defaulting to 50"));
        this._minQuestionCharCount = 50;
      }

      this._verison = process.env.REACT_APP_VERSION ? process.env.REACT_APP_VERSION + process.env.REACT_APP_STAGE.slice(-1) : "0.0.0";
      return true;
    }
  }, {
    key: "validateQueryParameters",
    value: function validateQueryParameters() {
      var _this2 = this;

      for (var _len = arguments.length, queryParams = new Array(_len), _key = 0; _key < _len; _key++) {
        queryParams[_key] = arguments[_key];
      }

      // check we actually have query params
      if (window.location.href.indexOf("?") === -1) {
        return false;
      }

      var params = decodeURIComponent(window.location.href.slice(window.location.href.indexOf("?") + 1));

      if (params === "") {
        return false;
      }

      params.split("&").forEach(function (param) {
        //there should only be 2 parts to a query param!
        var parts = param.split("=", 2);

        if (queryParams.indexOf(parts[0] > -1)) {
          if (!_this2._fixedMandatoryAttributes) {
            _this2["_".concat(parts[0])] = parts[1];
          } else if (!MANDATORY_ATTRIBUTES.includes(parts[0])) {
            _this2["_".concat(parts[0])] = parts[1];
          }
        }
      }); // check to ensure all params passed in have valid local members

      var invalidMembers = queryParams.filter(function (param) {
        return !_this2["_".concat(param)];
      });

      if (invalidMembers.length === 0) {
        return true;
      }

      return false;
    }
  }]);

  return ClientContext;
}();

export { ClientContext as default };